import React, { useEffect, useState } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { UseFormReturn } from 'react-hook-form'
import { addServerErrors } from '@/components/forms/common/FormBase'

export interface Namespace {
  id: string
  name: string
  createdAt?: string
}

export function useNamespaces(services: Services) {
  const [namespaces, setNamespaces] = useState<Namespace[]>()
  const [error, setError] = useState(false)
  useEffect(() => {
    let active = true
    services.session.fetchWithToken('/api/communal/namespaces').then(async r => {
      if (!r.ok) throw new Error('Namespaces unavailable')
      const data = await r.json()
      if (active) setNamespaces(data)
    }).catch(() => { if (active) setError(true) })
    return () => { active = false }
  }, [services])
  return { namespaces, error }
}

export async function namespaceFormErrors(form: UseFormReturn<any>, session: CurrentSession, response: Response) {
  try {
    const data = await response.json()
    addServerErrors(form, session.translates, data.errors ?? data)
  } catch {
    form.setError('_general', { message: session.translates.for('errors.namespace_request_failed') })
  }
}
